import { JavaAPI, JAVA_SERVICE_ENDPOINTS } from '@buildwise/libs/services';
import { ConfigType } from 'config/config';

export type ConfigResponseType = { config?: ConfigType; configs?: ConfigType[] };

class ConfigAPI extends JavaAPI {
  public getConfig({
    companyId,
    configName,
    configType,
    configCategory,
    productLevel,
  }: {
    companyId?: string;
    configName?: string;
    configType?: string;
    configCategory?: string;
    productLevel?: boolean;
  }) {
    const params = new URLSearchParams({
      ...(configType && {
        configType,
      }),
      ...(configCategory && {
        configCategory,
      }),
      ...(productLevel && {
        productLevel: 'true',
      }),
    });
    return this.get<ConfigResponseType>(
      `${(companyId ? JAVA_SERVICE_ENDPOINTS.COMPANY_CONFIG.replace(':companyId', companyId) : JAVA_SERVICE_ENDPOINTS.BUILDWISE_CONFIG).replace(':configName', configName || '')}${configType || configCategory || productLevel ? `?${params.toString()}` : ''}`,
    );
  }

  public deleteConfigByName({ companyId, configName }: { companyId?: string; configName: string }) {
    return this.delete<ConfigResponseType>(
      `${(companyId ? JAVA_SERVICE_ENDPOINTS.COMPANY_CONFIG.replace(':companyId', companyId) : JAVA_SERVICE_ENDPOINTS.BUILDWISE_CONFIG).replace(':configName', configName)}`,
    );
  }

  public deleteConfigById({ id }: { id: string }) {
    return this.delete<ConfigResponseType>(
      `${JAVA_SERVICE_ENDPOINTS.DELETE_CONFIG_BY_ID.replace(':id', id)}`,
    );
  }

  public updateConfig(config: ConfigType) {
    return this.put<ConfigResponseType>(JAVA_SERVICE_ENDPOINTS.UPDATE_CONFIG, config);
  }
}

const configAPI = new ConfigAPI();
export default configAPI;
